import React from 'react';
import { Dialog, Input, Radio, Upload } from 'tdesign-react';
import Form from '@/components/Form';

const { FormItem } = Form;

export default function ConformPwd({ visible, handleClose }) {
  const [form] = Form.useForm();
  const type = Form.useWatch('type', form);

  const handleSubmit = async (values) => {
    const parmas = {
      ...values,
    };
    // 秘钥
    if (type === '2') {
      parmas.prvKeyName = values.hostKey[0].name;
    }
    delete parmas.type;
    delete parmas.hostKey;
    handleClose(parmas);
  };

  return (
    <Dialog
      header={type === '1' ? '请输入密码进行验证' : '请上传密钥就行验证'}
      visible={visible}
      onClose={() => handleClose()}
      onConfirm={() => form.submit()}
      placement='center'
      destroyOnClose
    >
      <Form
        form={form}
        style={{ width: '90%' }}
        onFinish={handleSubmit}
        initialValues={{ type: '1' }}
      >
        <FormItem name='type' label='验证方式' rules={[{ required: true }]}>
          <Radio.Group>
            <Radio.Button value='1'>密码验证</Radio.Button>
            <Radio.Button value='2'>密钥验证</Radio.Button>
          </Radio.Group>
        </FormItem>
        {type === '1' && (
          <FormItem name='hostPassword' label='请输入密码' rules={[{ required: true }]}>
            <Input />
          </FormItem>
        )}
        {type === '2' && (
          <FormItem name='hostKey' label='上传秘钥' rules={[{ required: true }]}>
            <Upload
              theme='file'
              accept='application/x-x509-ca-cert'
              action='/api/ops_hosts/uploadPrvKey'
              headers={{ 'x-auth-token': localStorage.getItem('token') }}
            />
          </FormItem>
        )}
      </Form>
    </Dialog>
  );
}
